/*
represents open-ended JSON object for Communication settings
for MVP the cs1 cachefile is the only setting, but there will be more down the road
*/


class LocalizationSettings {
    subject?: string | null; // For app and email communications this is the subject or title of the message. May contain similar placeholders as the message.
    body?: string | null; 
    text?: string | null; 

    constructor(
        subject?: string | null, // For app and email communications this is the subject or title of the message. May contain similar placeholders as the message.
        body?: string | null, 
        text?: string | null 
    ) {
      this.subject = subject;
      this.body = body;
      this.text = text;

    }

    public static isEmpty = (localizationSettings : LocalizationSettings | undefined) => {
        if (!localizationSettings) {
            return true;
        }

        if( (localizationSettings.subject === "" || localizationSettings.subject === null || localizationSettings.subject === undefined) &&
        (localizationSettings.body === "" || localizationSettings.body === null || localizationSettings.body === undefined) &&
        (localizationSettings.text === "" || localizationSettings.text === null || localizationSettings.text === undefined)
        ){
            return true;
        }
        return false;
    }
  }
  
  export default LocalizationSettings;

  
  